(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-hover-blocks"] && !Shopify.designMode) return;
  try {
    
    class ExpandedCollection extends HTMLElement {
        constructor() {
            super();
            this.timeout = null;
            this.lastActiveItem = null;
            this.isClicked = false;
        }

        connectedCallback() {
            this.items = this.querySelectorAll('.dynamic-hover-blocks__item');
            this.activeItem = this.querySelector('[is-active]');

            if (this.querySelector('.no--image-stacked')) return;
            if (window.innerWidth >= 1025) {
                setTimeout(() => this.activeItem?.classList.add('active'), 500);
                this.items.forEach(item => {
                    item.addEventListener('mouseenter', this.onMouseEnter.bind(this));
                    item.addEventListener('mouseleave', this.onMouseLeave.bind(this));
                });

                this.addEventListener('mouseleave', this.onComponentLeave.bind(this));
            } else {
                document.addEventListener('scroll', this.onScroll.bind(this));

                this.items.forEach(item => {
                    item.addEventListener('click', this.onClick.bind(this));
                });
            }

            this.items.forEach(item => {
                item.querySelector('a').addEventListener('focus', () => this.setActive(item));
            });
        }

        setActive(item) {
            if (!item) return;
            this.items.forEach(el => el.classList.remove('active'));
            item.classList.add('active');
        }

        onMouseEnter(event) {
            this.setActive(event.target);
            clearTimeout(this.timeout);
        }

        onMouseLeave() {
            if (this.activeItem && this.activeItem.classList.contains('active')) return;
            this.items.forEach(item => item.classList.remove('active'));
        }

        onComponentLeave() {
            if (this.lastActiveItem) {
                this.lastActiveItem.classList.add('active');
            } else if (this.activeItem) {
                if (this.activeItem.classList.contains('active')) return;
                this.timeout = setTimeout(() => this.setActive(this.activeItem), 1000);
            }
        }

        onScroll() {
            if (this.isClicked) return;

            let closestItem = null;
            let minDistance = Infinity;

            this.items.forEach(item => {
                let rect = item.getBoundingClientRect();
                let itemCenter = rect.top + rect.height / 2;
                let distance = Math.abs(itemCenter - (window.innerHeight / 2));

                if (distance < minDistance) {
                    minDistance = distance;
                    closestItem = item;
                }
            });

            if (closestItem) {
                this.setActive(closestItem);
                this.lastActiveItem = closestItem;
            }
        }

        onClick(event) {
            this.isClicked = true;
            this.setActive(event.currentTarget);
        }
    }

    customElements.define('dynamic-hover-blocks', ExpandedCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = document.querySelector('.hlt-header');
      this.dropdownMenu = document.querySelectorAll('.header__submenu_level1');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.slideshowContent = document.querySelector('.slideshow__text-wrapper');
      this.headerBounds = {};
      this.setHeaderHeight();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.headerWrapper.offsetHeight}px`);
    }
    
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
    class ImageComparison extends HTMLElement {
        constructor() {
            super();
            this.active = false;
            this.button = this.querySelector('button');
            this.currentEvents = {};
            this.init();
        }

        init() {
            this.updateDragEvents();
            window.addEventListener('resize', this.updateDragEvents.bind(this));

            theme.initSectionVisible({
                element: this,
                callback: this.animate.bind(this),
                threshold: 400
            });
        }

        updateDragEvents() {
            const isMobile = window.innerWidth <= 989;
            const newEvents = isMobile ? { start: 'touchstart', move: 'touchmove', end: 'touchend' } : { start: 'mousedown', move: 'mousemove', end: 'mouseup' };

            if (JSON.stringify(this.currentEvents) !== JSON.stringify(newEvents)) {
                this.removeDragEvents();
                this.addDragEvents(newEvents.start, newEvents.move, newEvents.end);
                this.currentEvents = newEvents;
            }
        }

        addDragEvents(startEvent, moveEvent, endEvent) {
            this.button.addEventListener(startEvent, this.startHandler.bind(this));
            document.body.addEventListener(moveEvent, this.onHandler.bind(this), { passive: true });
            document.body.addEventListener(endEvent, this.endHandler.bind(this));
        }

        removeDragEvents() {
            if (this.currentEvents.start) {
                this.button.removeEventListener(this.currentEvents.start, this.startHandlerBound);
                document.body.removeEventListener(this.currentEvents.move, this.onHandlerBound);
                document.body.removeEventListener(this.currentEvents.end, this.endHandlerBound);
            }
        }

        animate() {
            this.setAttribute('animate', '');
            this.classList.add('animating');
            setTimeout(() => this.classList.remove('animating'), 1000);
        }

        startHandler() {
            this.active = true;
            this.classList.add('scrolling');
        }

        endHandler() {
            this.active = false;
            this.classList.remove('scrolling');
        }

        onHandler(e) {
            if (!this.active) return;
            const event = e.touches?.[0] || e;
            const x = event.pageX - this.offsetLeft;
            const halfWidth = (window.innerWidth <= 989) ? 25 : 36;

            const distance = this.clientWidth;
            const max = distance - halfWidth;
            const min = halfWidth;
            const mouseX = Math.max(min, (Math.min(x, max)));
            const mousePercent = (mouseX * 100) / distance;
            this.style.setProperty('--percent', `${mousePercent}%`);
        }
    }
    customElements.define('image-comparison', ImageComparison);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
    class MouseParallaxEffect extends HTMLElement {
        constructor() {
            super();
            this.itemEven = null;
            this.itemOdd = null;
            this.mouseMoveTimeout = null;
            this.lastMouseX = 0;
            this.lastMouseY = 0;

            this.isMouseInside = false;

            this.lastScrollTop = 0;
            this.currentStep = 0;
            this.maxStep = 30;
            this.stepFactor = 0.85;
            this.scrollTimeout = null;
            this.evenFactor = 1;

            this.lastEvenTransform = { x: 0, y: 0 };
            this.lastOddTransform = { x: 0, y: 0 };
        }

        connectedCallback() {
            this.itemEven = this.querySelectorAll('[parallax-item-even]');
            this.itemOdd = this.querySelectorAll('[parallax-item-odd]');

            if (!this.itemEven || !this.itemOdd) return;

            if (window.innerWidth >= 749) {
                this.addEventListener('mousemove', this.onHandler.bind(this), { passive: true });
                this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
                this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
            }

            window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
        }

        onHandler(e) {
            if (!this.isMouseInside) return;
            const rect = this.getBoundingClientRect();
            const mouseX = e.clientX - rect.left;
            const mouseY = e.clientY - rect.top;

            const evenX = (mouseX * -1) / 30;
            const evenY = (mouseY * 1) / 30;
            const oddX = (mouseX * 1) / 40;
            const oddY = (mouseY * -1) / 60;

            this.itemEven.forEach(even => even.style.transform = `translate3d(${evenX}px, ${evenY}px, 0)`);
            this.itemOdd.forEach(odd => odd.style.transform = `translate3d(${oddX}px, ${oddY}px, 0)`);

            this.lastEvenTransform = { x: evenX, y: evenY };
            this.lastOddTransform = { x: oddX, y: oddY };

            clearTimeout(this.mouseMoveTimeout);
            this.mouseMoveTimeout = setTimeout(() => {
                const deltaX = mouseX - this.lastMouseX;
                const deltaY = mouseY - this.lastMouseY;
                const extraMove = 20;

                this.itemEven.forEach(even => even.style.transform = `translate3d(${evenX + deltaX * extraMove / 100}px, ${evenY + deltaY * extraMove / 100}px, 0)`);

                this.itemOdd.forEach(odd => odd.style.transform = `translate3d(${oddX + deltaX * extraMove / 100}px, ${oddY + deltaY * extraMove / 100}px, 0)`);

                this.lastEvenTransform = {
                    x: evenX + deltaX * extraMove / 100,
                    y: evenY + deltaY * extraMove / 100,
                };
                this.lastOddTransform = {
                    x: oddX + deltaX * extraMove / 100,
                    y: oddY + deltaY * extraMove / 100,
                };
            }, 100);

            this.lastMouseX = mouseX;
            this.lastMouseY = mouseY;
        }

        onMouseEnter() {
            this.isMouseInside = true;
        }

        onMouseLeave() {
            this.isMouseInside = false;
        }

        onScroll() {
            const rect = this.getBoundingClientRect();
            const viewportHeight = window.innerHeight;

            if (rect.top <= viewportHeight && rect.bottom >= 0) {
                const scrollTop = window.scrollY || document.documentElement.scrollTop;
                const scrollDirection = scrollTop > this.lastScrollTop ? -1 : 1;
                this.lastScrollTop = scrollTop;

                this.currentStep = this.maxStep * scrollDirection;

                clearTimeout(this.scrollTimeout);
                if (!this.isMouseInside) this.applyScrollEffect();

                this.scrollTimeout = setTimeout(() => {
                    if (!this.isMouseInside && Math.abs(scrollTop - this.lastScrollTop) < 1) {
                        this.continueScrollEffect();
                    }
                }, 150);
            }
        }

        applyScrollEffect() {
            const evenX = window.innerWidth >= 749 ? this.lastEvenTransform.x : 0;
            const evenY = this.lastEvenTransform.y + this.currentStep * this.evenFactor;
            const oddX = window.innerWidth >= 749 ? this.lastOddTransform.x : 0;
            const oddY = this.lastOddTransform.y + this.currentStep;

            this.itemEven.forEach(even => even.style.transform = `translate3d(${evenX}px, ${evenY}px, 0)`);
            this.itemOdd.forEach(odd => odd.style.transform = `translate3d(${oddX}px, ${oddY}px, 0)`);

            this.currentStep *= this.stepFactor;
        }

        continueScrollEffect() {
            if (Math.abs(this.currentStep) > 0.5) {
                this.applyScrollEffect();
                setTimeout(() => {
                    this.continueScrollEffect();
                }, 100);
            }
        }
    }
    customElements.define('mouse-parallax-effect', MouseParallaxEffect);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  class CommentComponent extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.leave-a-comment');
      this.form = document.querySelector('.comment-form-inner');
      this.message = document.querySelector('.form-status-list');

      if (this.button != null) {
        this.button.addEventListener('click', this.toggleComment.bind(this));
      }

      if (this.message != null) {
        this.form.before(this.message);
      }
    }

    toggleComment(event) {
      event.preventDefault();
      event.stopPropagation();

      var $this = event.target,
          $formWrap = $this.parentNode.nextElementSibling,
          $formInner = $formWrap.querySelector('.comment-form-inner'),
          $form = $formWrap.querySelector('form'),
          $height = $form.offsetHeight + 45 + 'px'; // 45: margin top and margin bottom of $formWrap    

      if(!$this.classList.contains('is-open')) {
        $this.classList.add('is-open');
        $formWrap.classList.add('is-open');
        $formInner.style.maxHeight = $height;
      } else {
        $this.classList.remove('is-open');
        $formWrap.classList.remove('is-open');
        $formInner.style.maxHeight = '0';
      }
    }
  }
  customElements.define('comment-component', CommentComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
    class InfiniteScroll extends HTMLElement {
        constructor() {
            super();
            this.collectionList = this.closest('.collection-list');
            this.pagination = this.collectionList.querySelector('.pagination');
            this.button = this.querySelector('button');
            this.init();
            this.button.addEventListener('click', this.onClickHandler.bind(this));
        }

        init() {
            if (this.pagination.querySelector('.pagination-item--next')) this.classList.remove('hidden');
        }

        onClickHandler(event) {
            this.next = this.pagination.querySelector('.pagination-item--next');
            this.next ? this.load(this.next.querySelector('a').getAttribute('href')) : this.close();
        }

        load(url) {
            this.showLoading();
            fetch(url)
                .then((response) => response.text())
                .then((text) => {
                    this.hideLoading();
                    this.main = this.collectionList.querySelector('.collection-list-main');
                    this.index = this.main.querySelectorAll('li').length;
                    this.main.insertAdjacentHTML(
                        'beforeend',
                        new DOMParser().parseFromString(text, 'text/html').querySelector('.collection-list-main')
                            .innerHTML,
                    );
                    this.pagination.innerHTML = new DOMParser()
                        .parseFromString(text, 'text/html')
                        .querySelector('.pagination').innerHTML;
                    if (!this.pagination.querySelector('.pagination-item--next')) this.close();
                    this.focus(this.index);
                })
                .catch((e) => {
                    console.error(e);
                });
        }

        showLoading() {
            this.button.classList.add('loading');
            this.button.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        }

        hideLoading() {
            this.button.classList.remove('loading');
            this.button.querySelector('.loading-overlay__spinner').classList.add('hidden');
        }

        close() {
            this.button.setAttribute('aria-disabled', true);
            this.button.querySelector('.text').innerText = this.button.dataset.textNoMore;
        }

        focus(index) {
            const item = this.collectionList.querySelectorAll('.collection-list__item')[index];
            item.querySelector('.media').focus();
        }
    }
    customElements.define('infinite-scroll', InfiniteScroll);

  } catch(e) { console.error(e); }
})();
})();
